import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Button from '@everlane/button'
import LoadingAnimation from 'base/react/components/loading_animation'
import Input from 'base/react/components/form/input'
import store from 'base/store'

class SignInForm extends Component {
  static propTypes = {
    onSubmit: PropTypes.func,
    errors: PropTypes.object,
    initialEmail: PropTypes.string,
    inputClass: PropTypes.string,
    labelClass: PropTypes.string,
    buttonClass: PropTypes.string,
  }

  static defaultProps = {
    errors: {},
    onSubmit: () => {},
    initialEmail: '',
  }

  state = {
    email: this.props.initialEmail || '',
    password: '',
  }

  widgetId = null

  componentDidMount() {
    if (this.props.initialEmail?.length) {
      this.passwordInput.getInputRef().focus()
    }
    if (window.turnstile) {
      this.widgetId = window.turnstile.render('.cf-turnstile')
    }
  }

  componentWillUnmount() {
    window.turnstile.remove(this.widgetId)
  }

  renderTurnstileWidget() {
    const siteKey = store.getState().appConfig.turnstileSiteKey
    return <div className="cf-turnstile" data-sitekey={siteKey} data-theme="light" />
  }

  renderEmailField() {
    const onChange = event => this.setState({ email: event.currentTarget.value })

    return (
      <Input
        errorPosition="bottom"
        inputClass={this.props.inputClass}
        labelClass={this.props.labelClass}
        error={this.props.errors.email || null}
        placeholder="Email address"
        autoComplete="email"
        type="email"
        value={this.state.email}
        onChange={onChange}
      />
    )
  }

  renderPasswordField() {
    const onChange = event => this.setState({ password: event.currentTarget.value })

    return (
      <Input
        errorPosition="bottom"
        inputClass={this.props.inputClass}
        labelClass={this.props.labelClass}
        error={this.props.errors.password || null}
        autocomplete="password"
        type="password"
        name="password"
        placeholder="Password"
        value={this.state.password}
        onChange={onChange}
        ref={e => (this.passwordInput = e)}
      />
    )
  }

  handleClick = e => {
    e.preventDefault()
    const turnstile_code = window.turnstile.getResponse()
    this.props.onSubmit({ ...this.state, turnstile_code })
  }

  render() {
    const button = (() => {
      if (this.props.isLoading) {
        return <LoadingAnimation style={{ marginTop: 15 }} />
      }

      return (
        <Button
          className="flat-button--full-width"
          type="submit"
          onClick={this.handleClick}
          style={{ marginTop: 15 }}
          variant="rectangle"
          dark
        >
          Log In
        </Button>
      )
    })()

    return (
      <form disabled={this.props.isLoading}>
        {this.renderEmailField()}
        {this.renderPasswordField()}
        {this.renderTurnstileWidget()}
        {button}
      </form>
    )
  }
}
export default SignInForm
